import * as Sentry from '@sentry/browser'
import { Event, EventHint } from '@sentry/types'

export function initializeSentry (config: {
  dsn: string,
  release: string,
  environment: string
}): void {
  Sentry.init({
    ...config,
    ignoreErrors: [
      'Non-Error promise rejection captured with value'
    ],
    beforeSend(event: Event, hint: EventHint) {
      const error = hint.originalException
      const message = error instanceof Error ? error.message : error

      const ignoredError = /g_countrycode/i

      if (ignoredError.exec(String(message))) {
        return null
      }

      return event
    },
  })
}
